<template >

    <v-row class="limite-row">
        <v-col lg="4" sm="12" 
            v-for="bloc in blocs" 
            :key="bloc.text"
        >
            <a :href="`/${$i18n.locale}`+bloc.link" style="text-decoration: none" class="linkbloc colbloc">
                <v-card clas="colbloc" outlined class="img-linkbloc">

                    <v-img
                        :src="bloc.src"
                        class="white--text align-end imgbloc"
                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                        height="300px"
                        :data-aos="bloc.fade"
                        data-aos-duration="1000"
                        data-aos-delay="100"
                    >

                    <v-card-title v-text="bloc.text" class="textbloc" :class="bloc.class"></v-card-title>
                    
                    </v-img>

                </v-card>
            </a>
        </v-col>
     </v-row>

</template>

<script>

    /*  ../../src/assets/images/informacio.jpg */
export default {
    name: 'BlocsInici',
    props: [
        'i18n'
    ],
    data () {
        return {
            blocs : [
                { 
                    text: 'Consumibles', 
                    src: require('../../assets/images/products/bloc-inici-consumibles.jpg'), 
                    flex: 6,
                    link: '/consumibles/film-estirable-automatic',
                    class: 'textbloc-blocA',
                    fade: 'fade-right',
                },
                {   
                    text: 'Maquinaria', 
                    src: require('../../assets/images/products/flexadora.jpg'), 
                    flex: 6,
                    link: '/maquinaria/enfardadores',
                    class: 'textbloc-blocB',
                    fade: 'fade-in',
                },
                { 
                    text: 'Ecoproductos', 
                    src: require('../../assets/images/products/cintes-KRAFT.jpg'),
                    flex: 6,
                    link: '/eco-productes/sobres-packing-list-paper',
                    class: 'textbloc-blocC',
                    fade: 'fade-left',
                },
            ]
        }
    },
    methods: {
    },
    computed: {
        rutas () {
            return this.$router.options.routes;
        },
    }
}
</script>

<style scoped lang="scss">

.imgbloc {
    transition: all 1s ease-in-out;
    -webkit-filter: grayscale(100%); 
    filter: grayscale(100%);
    border: 5px solid transparent;

    &:hover {
        border: 10px solid white;
        background: conic-gradient(from 90deg, #fff, #000);
        filter:none;
    }
}
.linkbloc:hover + .img-linkbloc {
    border: 20px solid black;
}

.v-card.v-sheet.theme--light {
    background: no-repeat;
}

.textbloc {
    display: flex;
    text-align: center;
    align-content: center;
    justify-content: center;
    margin-top: -185px;
    font-size: 1.8em;
    color: rgb(255, 255, 255);
    background: rgba(5, 5, 5, 0.452);
    font-family: "Cabin", sans-serif;
    
    &-blocA {
        background: rgba(206, 69, 6, 0.452);
    }    

    &-blocB {
        background: rgba(4, 59, 179, 0.452);
    }
    &-blocC {
        background: rgba(6, 170, 20, 0.452);
    }

    &:hover {
        color: rgb(20, 20, 20) !important;
    }

    &-blocA:hover, &-blocC:hover, &-blocB:hover  {
        background: rgba(255, 255, 255, 0.712);
    }

    &:after {
        position: absolute;
        width: 300px;
        height: 300px;
        background: black;
        top: 100px;
        z-index: 1000;
    }

}

.v-image{
    border: 3px solid white;
}

</style>